export default __webpack_public_path__ + "static/media/otv.c19bf473.svg";